// this file is automatically generated by the build-information generator
export const build = {
    branch: 'undefined',
    commit: 'undefined',
    date: 'undefined',
    version: 'undefined'
};
